import React, { useRef, useEffect, useState } from "react";
//Components
import Modal from "./modal";
import Cart from "./cart";
import Offers from "./categories/offers";

//Outside Click
const useClickOutside = (handler) => {
  const domNode = useRef();
  useEffect(() => {
    const maybeHandler = (event) => {
      if (!domNode.current.contains(event.target)) {
        handler();
      }
    };
    document.addEventListener("mousedown", maybeHandler);
    return () => {
      document.removeEventListener("mousedown", maybeHandler);
    };
  });
  return domNode;
};

export default function ProductOffers() {
  const [showNotice, setShowNotice] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [activeObject, setActiveObject] = useState(null);
  function getClass(index) {
    return index === activeObject?.id ? "active" : "inactive";
  }

  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    const storedCartItems = localStorage.getItem("cartItems");
    if (storedCartItems) {
      setCartItems(JSON.parse(storedCartItems));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  const onAdd = (product) => {
    const exist = cartItems.find((x) => x.id === product.id);
    if (exist) {
      setCartItems(
        cartItems.map((x) =>
          x.id === product.id ? { ...exist, qty: exist.qty + 1 } : x,
        ),
      );
    } else {
      setCartItems([...cartItems, { ...product, qty: 1 }]);
    }
  };

  const onRemove = (product) => {
    const exist = cartItems.find((x) => x.id === product.id);
    if (exist.qty === 1) {
      setCartItems(cartItems.filter((x) => x.id !== product.id));
    } else {
      setCartItems(
        cartItems.map((x) =>
          x.id === product.id ? { ...exist, qty: exist.qty - 1 } : x,
        ),
      );
    }
  };

  function workingHours() {
    const now = new Date();
    const dayOfWeek = now.getDay();
    const hour = now.getHours();
    const minute = now.getMinutes();

    const isWeekday = dayOfWeek > 0 && dayOfWeek <= 5;
    const isSaturday = dayOfWeek === 6;
    const isSunday = dayOfWeek === 0;

    const isWithinWorkingHours =
      (isWeekday && hour >= 7 && (hour < 23 || (hour === 23 && minute < 30))) ||
      (isSaturday && (hour > 0 || (hour === 0 && hour < 24))) ||
      (isSunday && hour > 13 && hour < 24);

    setShowModal(isWithinWorkingHours);
  }

  return (
    <div>
      <Offers
        setActiveObject={setActiveObject}
        workingHours={workingHours}
        getClass={getClass}
      />
      {showModal ? (
        <Modal
          activeObject={activeObject}
          setShowModal={setShowModal}
          onAdd={onAdd}
          useClickOutside={useClickOutside}
          setShowNotice={setShowNotice}
        />
      ) : null}
      <Cart
        cartItems={cartItems}
        onAdd={onAdd}
        onRemove={onRemove}
        useClickOutside={useClickOutside}
        showNotice={showNotice}
      />
    </div>
  );
}
